var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{class:{
    'router-link-exact-active':
      _vm.isCurrentMeasure(this.$route.query.measures) && !this.$route.query.calculated,
  }},[_c('Flex',{class:{ 'cursor-pointer': true }},[_c('router-link',{staticClass:"measure-link",attrs:{"to":_vm.getRoute(_vm.measure, _vm.selectedSubOption)}},[_vm._v(" "+_vm._s(_vm.$t(_vm.measure.name))+" ")])],1),_c('DropDown',{attrs:{"options":_vm.measure.subOptions},on:{"updateOption":_vm.onSubOptionUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }